import { PublicClientApplication } from "@azure/msal-browser";
import azureService from "@/services/azure-service";

export async function handleAuthResponse(accountType) {
  const config = accountType === "work"
    ? azureService.getAzureAdConfig()
    : azureService.getAzureB2cConfig();
  const msalInstance = new PublicClientApplication(config);
  try {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No accounts found after login.");
    }
    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: ["openid", "profile", "email"],
      account: accounts[0],
    });
    return tokenResponse.idToken;
  } catch (error) {
    console.error("Error acquiring token:", error);
  }
} 